/**
 * Window-event bridge for the "latest changes to a note could not be kept"
 * notice (testimony plan rev 4, section 9.3; rule #26 pattern).
 *
 * PrayerDetail's testimony dialog dispatches this when the final draft write
 * issued on its unmount fails or is refused. The detail never carries the note
 * text: only the owner id and auth epoch captured when that write was issued,
 * and a unique failure id. TestimonyDraftNotice shows it only to that exact
 * session.
 *
 * Lives in `lib/` so the dispatcher (useTestimonyEdit) and the subscriber
 * (TestimonyDraftNotice.tsx) can both import it without violating
 * `react-refresh/only-export-components`.
 */

export const TESTIMONY_DRAFT_KEEP_FAILED_EVENT = 'adia:testimony-draft-keep-failed';

export interface TestimonyDraftKeepFailedDetail {
  ownerId: string;
  authEpoch: number;
  failureId: string;
}

export function dispatchTestimonyDraftKeepFailed(
  detail: TestimonyDraftKeepFailedDetail,
): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(
      new CustomEvent<TestimonyDraftKeepFailedDetail>(
        TESTIMONY_DRAFT_KEEP_FAILED_EVENT,
        { detail: { ...detail } },
      ),
    );
  } catch {
    // Older browsers without CustomEvent: the stored draft is unaffected.
  }
}
